

import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import SuperCorrectiveActionReport from "./SuperCorrectiveActionReport";
import Select from "react-select";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";

function NcReportModal_1({ show, handleClose,productId }) {
  const [superCorrectiveActionReport, setSuperCorrectiveActionReport] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [formData, setFormData] = useState({
    selectedProduct: null,
    selectedType: null,
    ncQuantity: "",
    unit: "",
    description: "",
  });
  const [errors, setErrors] = useState({});

  const fetchProductList = async () => {
    const token = getAuthToken();
    if (!token) return;
    setListLoading(true);
    try {
      const res = await axios.get(`${config.API}/product/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProductList(res.data.products || []);
    } catch (err) {
      console.error("Error fetching product list:", err);
      toast.error("Failed to load product list");
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    fetchProductList();
  }, []);

  const productOptions = productList.map((product) => ({
    value: product.name,
    label: product.name,
  }));

  const typeOptions = [
    { value: "Metal Component", label: "Metal Component" },
    { value: "Plastic Component", label: "Plastic Component" },
  ];

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [field]: null,
    }));
  };

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("No authentication token found");
      return;
    }

    try {
      const payload = {
        product_type: formData.selectedType ? formData.selectedType.value : "",
        product_name: formData.selectedProduct ? formData.selectedProduct.value : "",
        nc_quantity: formData.ncQuantity,
        unit: formData.unit,
        nc_reason: formData.description,
      };

    

      const res = await axios.post(`${config.API}/supervisor/ncreportnew`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      console.log("Response:", res.data);
      toast.success(res.data.message || "NC Report submitted successfully");

      // Reset form
      setFormData({
        selectedProduct: null,
        selectedType: null,
        ncQuantity: "",
        unit: "",
        description: "",
      });
      setErrors({});
      handleClose();
    } catch (err) {
      if (err.response?.status === 422 && err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        toast.error(err.response?.data?.message || "Something went wrong");
      }
      console.error("Error submitting NC report:", err.response?.data || err.message);
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered className="font_family">
        <Modal.Body className="p-5">
          <strong className="fs-4">Nc Reports</strong>
          <Form>
            <Row className="mb-3 mt-3">
              <Col md={4} className="d-flex align-items-center">
                <Form.Label className="mb-0"><strong>Product Type</strong></Form.Label>
              </Col>
              <Col md={8}>
                <Select
                  options={typeOptions}
                  value={formData.selectedType}
                  onChange={(option) => handleChange("selectedType", option)}
                  placeholder="Select Product Type"
                />
                {errors.product_type && <div className="text-danger">{errors.product_type}</div>}
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4} className="d-flex align-items-center">
                <Form.Label className="mb-0"><strong>Product Name</strong></Form.Label>
              </Col>
              <Col md={8}>
                <Select
                  options={productOptions}
                  value={formData.selectedProduct}
                  onChange={(option) => handleChange("selectedProduct", option)}
                  isLoading={listLoading}
                  placeholder="Select Product"
                />
                {errors.product_name && <div className="text-danger">{errors.product_name}</div>}
              </Col>
            </Row>

            <Form.Group className="mt-3">
              <Row className="align-items-center">
                <Col md={4}>
                  <Form.Label>NC Quantity</Form.Label>
                </Col>
                <Col md={3}>
                  <Form.Control
                    type="number"
                    value={formData.ncQuantity}
                    onChange={(e) => handleChange("ncQuantity", e.target.value)}
                  />
                  {errors.nc_quantity && <div className="text-danger">{errors.nc_quantity}</div>}
                </Col>
                <Col md={2}>
                  <Form.Label>Unit</Form.Label>
                </Col>
                <Col md={3}>
                  <Form.Control
                    type="text"
                    value={formData.unit}
                    onChange={(e) => handleChange("unit", e.target.value)}
                  />
                  {errors.unit && <div className="text-danger">{errors.unit}</div>}
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mt-3" controlId="ncReason">
              <Row>
                <Col md={3}><Form.Label><strong>NC Reason</strong></Form.Label></Col>
                <Col md={9}>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Enter NC Reason"
                    value={formData.description}
                    onChange={(e) => handleChange("description", e.target.value)}
                  />
                  {errors.nc_reason && <div className="text-danger">{errors.nc_reason}</div>}
                </Col>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer className="border-0 mb-3">
          <Button variant="outline-dark" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="outline-dark" onClick={() => setSuperCorrectiveActionReport(true)}>
            Add Corrective Measure
          </Button>
          <Button className="btn btn-dark" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      {/* SuperCorrectiveActionReport Modal */}
      <SuperCorrectiveActionReport
         productId={productId}
        show={superCorrectiveActionReport}
        handleClose={() => setSuperCorrectiveActionReport(false)}
      />
    </>
  );
}

export default NcReportModal_1;
